import { VFC } from "react";

// Libraries
import { DateTime } from "luxon";

// Components
import { Flex, Image, Paper, Spacer, Text, Title } from "components";
import { AnimalsBreedPill } from "components/MyLivestock";
import { AnimalDataTypes } from "../";

// Resources
import animalOverviewEmptyState from "assets/img/Blockchain/animalOverview-emptyState.png";
import styles from "./BlockchainAnimalOverview.module.scss";

interface BlockchainAnimalOverviewProps {
  animal: AnimalDataTypes | null;
}

export const BlockchainAnimalOverview: VFC<BlockchainAnimalOverviewProps> = ({ animal }) => {
  const animalGender = animal?.isMale ? "male" : "female";
  const animalDob = animal?.dob ? DateTime.fromISO(animal.dob).toLocaleString() : "--";

  return (
    <>
      <Title secondary>Animal Overview</Title>

      <Spacer baselineHeight={1}></Spacer>

      <Paper className={styles.blockchainAnimalOverview}>
        <Spacer baselineHeight={4}></Spacer>

        {!animal || animal.error ? (
          <>
            <Flex container containerJustifyContent="center">
              <Text>Fill in the form on the left to access the blockchain</Text>
            </Flex>

            <Spacer baselineHeight={2}></Spacer>

            <Image src={animalOverviewEmptyState}></Image>
          </>
        ) : (
          <>
            <Flex container>
              <Flex item itemGutter xs={3}>
                <Text>Owner Holding ID</Text>

                <br />

                <Text>
                  <strong>{animal.ownerHoldingId || "--"}</strong>
                </Text>
              </Flex>
              <Flex item itemGutter xs={3}>
                <Text>Owner Name</Text>

                <br />

                <Text>
                  <strong>{animal.ownerName || "--"}</strong>
                </Text>
              </Flex>
            </Flex>

            <Spacer baselineHeight={3}></Spacer>

            <Flex container>
              <Flex item itemGutter xs={3}>
                <Text>Passport No.</Text>

                <br />

                <Text>
                  <strong>{animal.passportNumber || "--"}</strong>
                </Text>
              </Flex>

              <Flex item itemGutter xs={3}>
                <Text>Owner ID</Text>

                <br />

                <Text>
                  <strong>{animal.ownerId || "--"}</strong>
                </Text>
              </Flex>
            </Flex>

            <Spacer baselineHeight={3}></Spacer>

            <Flex container>
              <Flex item itemGutter xs={3}>
                <Text>Date of Birth</Text>

                <br />

                <Text>
                  <strong>{animalDob}</strong>
                </Text>
              </Flex>

              <Flex item itemGutter xs={3}>
                <Text>Breed</Text>

                <br />

                <AnimalsBreedPill name={animal.breed || "Unknown Breed"} quantity={1} sex={animalGender} />
              </Flex>
            </Flex>

            <Spacer baselineHeight={3}></Spacer>

            <Flex container>
              <Flex item itemGutter xs={3}>
                <Text>Name</Text>

                <br />

                <Text>
                  <strong>{animal.name || "--"}</strong>
                </Text>
              </Flex>
            </Flex>
          </>
        )}

        <Spacer baselineHeight={4}></Spacer>
      </Paper>
    </>
  );
};
